import React from "react";
import { Avatar } from "@mui/material";
import KontactPng from "../../static/img/products/Kontact.png";

function Kontact(props) {
  return <Avatar variant={props.variant} src={KontactPng} alt={props.alt} sx={props.sx} />;
}

export default Kontact;
